import {Map} from "immutable"

import {DemandList, JsonData as DemandJsonData, fromJs as demandFromJs} from "./../model/Demand"
import {Divisions, JsonData as DivisionJsonData, fromJs as divisionFromJs} from "./../model/Division"
import {Regions, JsonData as RegionJsonData, fromJs as regionFromJs} from "./../model/Region"
import {UniversityBranches, JsonData as UniversityBranchJsonData, fromJs as universityBranchFromJs} from "./../model/UniversityBranch"
import {Specialities, JsonData as SpecialityJsonData, fromJs as specialityFromJs} from "./../model/Speciality"
import {JsonData as UserJsonData, fromJs as userFromJs} from "./../model/User"
import {Finance} from "../model/Finance";

import {
    createWorkbook,
    addWorksheet,
    addFilter,
    composeXlsx,
    getStream,
} from "./../Excel/export"
import {logger} from "../utils/logger";
import {demandWs} from "./demandWs"
import {targetRequestWs} from "./targetRequestWs"
import {entranceWs} from "./entranceWs"
import {studentsWs} from "./studentsWs"
import {vacanciesWs} from "./vacanciesWs"
import {traineesWs} from "./traineesWs";
import {financesWs} from "./financesWs";
import {IS_SUMMER} from "./common";

const isSummer = IS_SUMMER

export type JsonData = {
    demand: DemandJsonData[]
    divisions: DivisionJsonData[]
    regions: RegionJsonData[]
    specialities: SpecialityJsonData[]
    universityBranches: UniversityBranchJsonData[]
    finances: Finance[]
    monitoring2019Data: {
        demandNuclear: {[year: string]: number}
        demandTotal: {[year: string]: number}
        targetRequestNuclear: {[year: string]: number}
        targetRequestTotal: {[year: string]: number}
    }
    meta: {
        company: string
        user: UserJsonData
    }
}

const exportXlsx = (data: JsonData) => {
    let wb = createWorkbook()

    const specialities = <Specialities>Map(data.specialities.map(speciality => [speciality.id, specialityFromJs(speciality)]))
    const demand = <DemandList>Map(data.demand.map(demand => [demand.id, demandFromJs(demand, specialities)]))
    const divisions = <Divisions>Map(data.divisions.map(division => [division.id, divisionFromJs(division)]))
    const regions = <Regions>Map(data.regions.map(region => [region.id, regionFromJs(region)]))
    const universityBranches = <UniversityBranches>Map(data.universityBranches.map(universityBranch => [universityBranch.id, universityBranchFromJs(universityBranch)]))
    const finances = data.finances
    const monitoring2019Data = data.monitoring2019Data

    const meta = {
        company: data.meta.company,
        user: userFromJs(data.meta.user)
    }

    console.time("data")

    const demandSheet = demandWs({
        demand,
        divisions,
        specialities,
        regions,
        universityBranches,
        meta,
        monitoring2019Data: {
            total: monitoring2019Data.demandTotal,
            nuclear: monitoring2019Data.demandNuclear
        },
    })
    const targetRequestSheet = targetRequestWs({
        demand,
        divisions,
        specialities,
        regions,
        universityBranches,
        meta,
    })

    const entranceSheet = entranceWs({
        demand,
        divisions,
        specialities,
        regions,
        universityBranches,
        meta,
    })

    const studentsSheet = studentsWs({
        demand,
        divisions,
        specialities,
        regions,
        universityBranches,
        meta,
    })

    const vacanciesSheet = vacanciesWs({
        demand,
        divisions,
        specialities,
        regions,
        universityBranches,
        meta,
    })

    const traineesSheet = traineesWs({
        demand,
        divisions,
        specialities,
        regions,
        universityBranches,
        meta,
    })

    const financesSheet = financesWs({
        finances,
        divisions,
        regions,
        universityBranches,
        meta,
    })

    console.timeEnd("data")
    console.time("addSheets")

    wb = addWorksheet(wb, demandSheet.sheet, demandSheet.title)
    wb = addWorksheet(wb, vacanciesSheet.sheet, vacanciesSheet.title)
    wb = addWorksheet(wb, entranceSheet.sheet, entranceSheet.title)
    wb = addWorksheet(wb, targetRequestSheet.sheet, targetRequestSheet.title)
    wb = addWorksheet(wb, studentsSheet.sheet, studentsSheet.title)
    wb = addWorksheet(wb, traineesSheet.sheet, traineesSheet.title)
    if (!isSummer) {
        wb = addWorksheet(wb, financesSheet.sheet, financesSheet.title)
    }

    console.timeEnd("addSheets")

    console.time("wb")

    let zip = composeXlsx(wb)

    console.timeEnd("wb")
    console.time("zip")

    zip = addFilter(zip, demandSheet.filter.columns, {row: demandSheet.filter.row})
    zip = addFilter(zip, vacanciesSheet.filter.columns, {row: vacanciesSheet.filter.row, sheetIndex: 1})
    zip = addFilter(zip, entranceSheet.filter.columns, {row: entranceSheet.filter.row, sheetIndex: 2})
    zip = addFilter(zip, targetRequestSheet.filter.columns, {row: targetRequestSheet.filter.row, sheetIndex: 3})
    zip = addFilter(zip, studentsSheet.filter.columns, {row: studentsSheet.filter.row, sheetIndex: 4})
    zip = addFilter(zip, traineesSheet.filter.columns, {row: traineesSheet.filter.row, sheetIndex: 5})
    if (!isSummer) {
        zip = addFilter(zip, financesSheet.filter.columns, {row: financesSheet.filter.row, sheetIndex: 6})
    }

    getStream(zip, "Предварительный отчет")

    console.timeEnd("zip")
    console.timeEnd("export")
    document.body.classList.remove("nojs")
}

export const exportPrior = (id?: number) => {
    console.time("export")

    document.body.classList.add("nojs")
    fetch("/export/prior" + (id ? "/" + id : ""), {credentials: "include"})
        .then(response => response.json())
        .then<JsonData>(response => response as any)
        .then(exportXlsx)
        .catch(error => logger.captureException(error))
}
